<template>
  <div>
    <Summary v-model="maximizeCard" :module_id="35" />
    <vs-col :vs-xs="6" :vs-md="3" :vs-lg="3">
      <vs-input
        placeholder="Search"
        class="w-full"
        v-model="search"
        @keyup="searchFun"
        style="width: 100%"
      />
    </vs-col>

    <vs-button
      @click="togglePopUp('add')"
      class="block ml-auto mb-4"
      v-if="checkCreatePermission()"
      >Add Subject</vs-button
    >
    <vx-card class="pb-10">
      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :tooltipMouseTrack="true"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="rowData"
        rowSelection="multiple"
        :enableRtl="$vs.rtl"
        colResizeDefault="true"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @grid-ready="onGridReady"
        @sortChanged="sortFun"
      >
      </ag-grid-vue>
      <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
        <vs-col vs-w="4" vs-type="flex" vs-justify="start" vs-align="center">
          <ItemsPerTableDropdown
            tableName="subject_table"
            @change="pageLimit => (pageLimitSet = pageLimit)"
          />
        </vs-col>
        <pagination
          :meta="meta"
          @page-change="handlePageChange"
          class="ml-auto"
        />
      </vs-row>
    </vx-card>

    <!-- {{addSubjectPopup}} -->

    <vs-popup
      :title="subject_name == '' ? 'Add Subject' : 'Edit Subject'"
      :active.sync="addSubjectPopup"
    >
      <form data-vv-scope="addSub" v-if="addSubjectPopup">
        <label class="text-sm">Subject Name</label>
        <vs-input
          class="inputx mb-2 w-full"
          v-validate="'required'"
          name="Subject Name"
          v-model="subject_name"
        />
        <span
          v-show="errors.has('addSub.Subject Name')"
          class="text-danger block"
          >{{ errors.first("addSub.Subject Name") }}</span
        >
        <label class="text-sm">Subject Description</label>
        <vs-textarea
          class="mb-2 w-full"
          name="subdesc"
          v-model="subject_description"
        />

        <vs-col
          :vs-xs="12"
          :vs-md="12"
          :vs-lg="12"
          class="p-2 centerx"
          vs-type="flex"
          vs-justify="space-between"
        >
          <FileUpload
            section_type="courseHeader"
            :multiplefile="false"
            @getFileIdHeader="getIdFile"
            :file_repository_id="repository_id"
            :filesInfo="filesInfo"
            @deletedIndex="deletedIndex"
            ref="fileUploadRef"
          >
          </FileUpload>
        </vs-col>
        <vs-divider />
        <vs-button
          @click="updateSubject"
          class="mt-2"
          type="filled"
          v-if="this.editedSubjectId"
          >Update Subject</vs-button
        >
        <vs-button @click="add_subject" class="mt-2" type="filled" v-else
          >Create Subject</vs-button
        >
      </form>
    </vs-popup>
    <!--   <vs-popup title="Edit Subject" :active.sync="editSubjectPopup">
            <form data-vv-scope="addSub1">
                <label class="text-sm">Subject Name</label>
                <vs-input class="inputx mb-2 w-full" v-validate="'required'" data-vv-name="Name" v-model="editeditem.subject_name" />
                <span
                    v-show="errors.has('addSub1.Name')"
                    class="text-danger block"
                  >{{ errors.first('addSub1.Name') }}</span>
                <label class="text-sm">Subject Description</label>
                <vs-textarea class="mb-2 w-full" data-vv-name="Description" v-model="editeditem.subject_description" />
            
              
                        <vs-col v-if="editeditem.subject_image"> Previous Image:
                      <img class="sub-img" v-bind:src= "editeditem.subject_image" >
                      </vs-col>

                 <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2 centerx" vs-type="flex" vs-justify="space-between">
            <div>
              <label for="myfile">Select a file:</label>
            <input type="file" id="myfile" name="myfile" @change="uploadImg($event, 1)"></div>
            <vs-button color="primary" @click="saveeditImage">Upload</vs-button>
          </vs-col>

                <vs-divider/>
                <vs-button class="mt-2" type="filled" @click="updateSubject">Update Subject</vs-button>
            </form>
        </vs-popup> -->

    <vs-popup title="Warning" :active.sync="additionalPopUp">
      <additional-info-component
        v-if="additionalPopUp"
        :additionalInfo="additionalInfo"
      ></additional-info-component>
    </vs-popup>
  </div>
</template>
<script>
import CellRendererSubjectAction from './CellRendererSubjectAction.vue'
import CellImageRender from './CellImageRender.vue'
// import CellActiveRender from "./CellActiveRender.vue"
import { AgGridVue } from 'ag-grid-vue'
import Vue from 'vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import Summary from '../analytics/summeryLIst'
import {
  list_subject,
  create_subject,
  subject_update,
  delete_subject,
  checkingSubjectAssociaton
} from '@/api/subject'
import Pagination from '@/components/common/pagination'
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'
import AdditionalInfoComponent from './components/AdditionalInfoComponent.vue'
import FileUpload from '@/components/common/FileUpload'
import { repository } from '@/mixins/repository.js'

export default {
  name: 'Subjects',
  components: {
    Pagination,
    AdditionalInfoComponent,
    FileUpload,
    Summary,
    AgGridVue,
    Vue,
    CellRendererSubjectAction
  },
  mixins: [PermissionMiddleware, repository],
  beforeMount () {
    this.columnDefs = [
      {
        headerName: '#',
        field: 'row_index',
        filter: false,
        minWidth: 100,
        maxWidth: 100,
        sortable: false,
        editable: false,
        valueGetter:(params) => {
          return ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
        }
      },
      {
        headerName: 'Name',
        field: 'subject_name',
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false
      },
      {
        headerName: 'Description',
        field: 'subject_description',
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false
      },
      {
        headerName: 'Image',
        field: 'subject_image',
        filter: true,
        minWidth: 120,
        resizable: true,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(CellImageRender)
      },

      {
        headerName: 'Actions',
        field: 'actions',
        minWidth: 100,
        maxWidth: 100,
        resizable: true,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(CellRendererSubjectAction),
        filterParams: { openConfirm: this.openConfirm, editSub: this.editSub }
      }
    ]
  },
  created () {
    this.getRepositoryId(35)
    //this.checkingQuery('/pages/subjects')
    //checking school admin ->set schooladmin to true
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Subject')
    }

    //
  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    },
    addSubjectPopup () {
      if (!this.addSubjectPopup) {
        this.subject_name = ''
        this.subject_description = ''
        this.subject_image = ''
        this.file_id = null
        this.editedSubjectId = null
        this.filesInfo.splice(0)
      }
    }
  },
  data () {
    return {
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      pageLimitSet: 5,
      frameworkComponents: null,
      columnDefs: [],
      gridApi: null,
      gridOptions: {
        accentedSort: true
      },
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      rowData: [],

      maximizeCard: true,
      subjectlist: [],
      addSubjectPopup: false,
      editSubjectPopup: false,
      subject_name: '',
      subject_description: '',
      subject_image: '',
      file_id: null,
      fileimage: null,
      preview: null,
      student: [],
      fileeditedimage: null,
      editedSubjectId: '',
      fileName: '',
      imageDataUrl: null,
      deleted_id: '',
      search: '',

      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      /* meta: {
        page: 1
      }, */
      additionalInfo: [],
      additionalPopUp: false,
      filesInfo: []
    }
  },

  mounted () {
    // this.fetchSubjectList()
    this.gridApi = this.gridOptions.api
  },
  methods: {
    async sortFun () {
      try {
        const sortState = this.gridApi.getSortModel()
        if (sortState.length === 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = sortState[0].colId
          this.sorting_obj.direction = sortState[0].sort

          this.$vs.loading({
            text: 'Loading...'
          })
          this.fetchSubjectList()
        }
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      try {
        vm.fetchSubjectList()
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    getIdFile (obj) {
      if (Array.isArray(obj)) {
        this.file_id = obj[0]
      } else {
        this.file_id = obj
        console.log(obj)
      }

      /*  if (Array.isArray(obj)) {
        this.file_ids = [...this.file_ids, ...obj]
      } else {
        this.file_ids.push(obj)

      } */
    },
    togglePopUp (toggle) {
      if (toggle === 'add') {
        this.$validator.reset()
        this.addSubjectPopup = true
      }
    },
    add_subject () {
      this.$validator.validateAll('addSub').then(valid => {
        if (valid) {
          const request_parameter = {
            // subject_image: this.subject_image,
            subject_name: this.subject_name,
            subject_description: this.subject_description,
            file_id: this.file_id
          }
          this.createSubject(request_parameter)
        }
      })
    },
    editSub (data) {
      // const data = this.subjectlist.find(element => element.id === subjectId)
      console.log(data)

      this.subject_name = data.subject_name
      this.subject_description = data.subject_description
      this.subject_image = data.subject_image
      this.editedSubjectId = data.id
      this.file_id = data.file ? data.file.file_id : null
      if (data.file) {
        this.filesInfo.splice(0)
        this.filesInfo.push({ file: data.file })
      }
      // this.filesInfo = data.file

      this.addSubjectPopup = true
      // this.temp = indextr
      //
    },
    deletedIndex (deleteIndex) {
      console.log(deleteIndex)
      this.filesInfo.splice(0)
      console.log(this.filesInfo)
      this.file_id = null
      /* this.file_ids.splice(deleteIndex, 1)
      this.filesInfo.splice(deleteIndex, 1) */
    },
    async updateSubject () {
      // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      // const userId = userInfo.id
      const userId = this.$store.getters.customerId

      try {
        const request_parameter = {
          // subject_image: this.subject_image,
          subject_name: this.subject_name,
          subject_description: this.subject_description,
          file_id: this.file_id
        }
        const { data } = await subject_update(
          userId,
          this.editedSubjectId,
          request_parameter
        )
        this.$vs.notify({
          title: 'Success',
          text: 'Subject Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        const dataIndex = this.subjectlist.findIndex(
          element => element.id === this.editedSubjectId
        )
        console.log(this.subjectlist)
        console.log(dataIndex)
        console.log(data.data)
        this.rowData[dataIndex].subject_name = data.data.subject.subject_name
        this.rowData[dataIndex].subject_description =
          data.data.subject.subject_description
        this.rowData[dataIndex].subject_image = data.data.subject.subject_image
        this.rowData[dataIndex].file = data.data.subject.file
        this.gridOptions.api.refreshCells()
        console.log(this.rowData)
        this.addSubjectPopup = false

        // this.setDefaultEditValue()
      } catch (error) {
        console.warn(error)
      }
    },

    async openConfirm (id) {
      const customer_id = this.$store.getters.customerId
      const resonseChecking = await checkingSubjectAssociaton(customer_id, id)

      if (resonseChecking.data.data.flag) {
        this.additionalInfo = resonseChecking.data.data.additionalInfo
        // this.additionalPopUp = true
        this.$vs.notify({
          title: 'Warning',
          text: 'You can not delete this as this has been referred to somewhere else.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        this.deleted_id = id
        //
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this subject?',
          accept: this.acceptAlert,
          acceptText: 'Yes',
          cancelText: 'No'
        })
      }
    },
    acceptAlert () {
      this.deleteSub(this.deleted_id)
    },
    async deleteSub (id) {
      // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      // const userId = userInfo.id
      const userId = this.$store.getters.customerId

      try {
        await delete_subject(userId, id)

        const deleteIndex = this.subjectlist.findIndex(
          element => element.id === id
        )

        this.subjectlist.splice(deleteIndex, 1)

        if (this.subjectlist.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }

        this.$vs.notify({
          title: 'Success',
          text: 'Subject Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.deleted_id = ''
      } catch (e) {
        //
      }
    },

    async fetchSubjectList () {
      this.$vs.loading({ text: 'Fetching Subject List...' })
      // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      // const userId = userInfo.id
      const customerId = this.$store.getters.customerId
      const payload = {
        search: this.search,
        limit: this.pageLimitSet
      }
      try {
        const { data } = await list_subject(
          customerId,
          this.meta.current_page,
          payload,
          this.sorting_obj
        )
        this.subjectlist = data.data.subjectlist
        this.rowData = this.subjectlist
        this.meta = data.data.meta
      } catch (e) {
        console.log(e)
      } finally {
        this.$vs.loading.close()
      }
    },
    async createSubject (payload) {
      try {
        const customerId = this.$store.getters.customerId
        // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // const userId = userInfo.id
        const { data } = await create_subject(customerId, payload)

        this.addSubjectPopup = false
        const arrObj = {
          id: data.data.subject.id,
          subject_description: data.data.subject.subject_description,
          subject_image: data.data.subject.subject_image,
          subject_name: data.data.subject.subject_name,
          file: data.data.subject.file
        }

        this.$vs.notify({
          title: 'success',
          text: 'Subject Created successfully',
          icon: 'feather',
          iconPack: 'icon-alert-circle',
          color: 'success'
        })

        this.subjectlist.unshift(arrObj)
        console.log(this.subjectlist)
        this.setDefaultValue()
      } catch (error) {
        //
      }
    },
    handlePageChange (page) {
      //
      const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = 10
      this.meta.current_page = page
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({ path: '/pages/subjects', query: queryPayload  }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      // this.fetch_list(queryPayload)
      this.fetchSubjectList()
    },
    setDefaultValue () {
      this.subject_name = ''
      this.subject_description = ''
      this.subject_image = null
      this.editedSubjectId = null
      this.file_id = null
    }
  }
}
</script>
<style>
.vs-table--tbody-table tr {
  border-bottom: 1px solid #e2e2e2;
}
.sub-img {
  width: 70px;
  height: 70px;
  object-fit: contain;
}
.subject_listing_table tr th:nth-child(1) {
  min-width: 150px;
}
.subject_listing_table tr th:nth-child(2) {
  min-width: 250px;
}
.subject_listing_table th:last-child .vs-table-text {
  text-align: center;
  justify-content: center;
}
.subject_listing_table td:last-child {
  width: 100px;
}
</style>
